import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import "../../utils/YupHelper";

export interface ResetPasswordData {
    username: string;
    password: string;
    confirmPassword: string;
}

export class ResetPassword implements FormValidationModel<ResetPasswordData> {
    public data: ResetPasswordData;
    public rules: yup.Schema<ResetPasswordData>;

    public constructor() {
        this.data = {
            username: "",
            password: "",
            confirmPassword: "",
        };
        this.rules = yup.object<ResetPasswordData>().shape({
            username: yup.string().email().required().label("Username").max(50),
            password: yup.string().required().label("New password").min(8).max(50),
            confirmPassword: (yup.string().required().label("Confirm password").max(50) as any)
                .equalTo(yup.ref("password"), "New password and confirm password fields do not match"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/account/ResetPassword.ts